var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-content"},[_c('div',{staticClass:"box parentflex"},[_c('p',[_vm._v("今日单片能耗")]),_c('div',{staticClass:"count"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"pagebox"},[_c('div',{attrs:{"id":"ganuge"}})])])])])])
}]

export { render, staticRenderFns }